import React from 'react';
import Row from "@Containers/components/Row";
import Translation from "@Translation/components/Translation";
import Column from "@Containers/components/Column";
import IconPenTrvl from "@Icons/edit/IconPen";
import {useAppDispatch} from "@Hooks/dispatch/useAppDispatch";
import {clearPassengerSubmissionData} from "@CheckOrder/reducers/checkOrderSlice";
import {useAppSelector} from "@Hooks/selector/useAppSelector";
import PaymentSummary from "@CheckOrder/features/paymentSummary/components/PaymentSummary";
import IconEmail from "@Icons/chat/IconEmail";
import {isPassengerVehicle} from "@CheckOrder/functions/isPassengerVehicle";
import PassengerType from "@CheckOrder/types/Passenger.type";
import VehicleAddonType from "@CheckOrder/types/VehicleAddon.type";
import VehicleAddonInfo
    from "@CheckOrder/features/addons/features/jadrolinija/features/selectedVehicleAddon/components/VehicleAddonInfo";
import {isNotEmpty} from "@Array/isNotEmpty";

function PaymentInfoSection() {
    const {
        passengers,
        email,
        purchasedRoute: {
            passengerGroups,
        },
    } = useAppSelector((state) => state?.checkOrder)
    const dispatch = useAppDispatch()

    const goBackToEdit = () => {
        dispatch(clearPassengerSubmissionData())
    }

    const normalPassengers: PassengerType[] = []
    const vehiclePassengers: VehicleAddonType[] = []

    passengers.map((passenger) => (
        isPassengerVehicle(passenger) ? vehiclePassengers.push(passenger) : normalPassengers.push(passenger)
    ))

    return (
        <>
            <div className="gb--card gb--check-order__payment-form-summary">
                <Row center justify className="gb--card-title edit-passengers__section">
                    <Translation translationKey="form.passengers.label"/>
                    <button
                        onClick={goBackToEdit}
                        type="button"
                    >
                        <IconPenTrvl/>
                        <Translation translationKey="sys.edit"/>
                    </button>
                </Row>
                <Row wrap className="passengers-list">
                    {normalPassengers.map((passenger) => (
                        <span className="passengers-list__summary">
                            {`${passenger.passengerFirstName} ${passenger.passengerLastName || passengerGroups[passenger.singlePassengerGroupId].name}`}
                        </span>
                    ))}
                </Row>
                {isNotEmpty(vehiclePassengers) && (
                    <>
                        <hr/>
                        <div className="gb--card-title">
                            <Translation translationKey="check_order.addons.JADL.vehicle.edit_cta"/>
                            <div className="gb--card-title ticket-addons__selected-list">
                                {vehiclePassengers.map((vehicle) => (
                                    <VehicleAddonInfo
                                        vehicle={vehicle}
                                    />
                                ))}
                            </div>
                        </div>
                    </>
                )}
                <hr/>
                <Column className="contact-summary">
                    <Row center gap className="contact-summary__email">
                        <IconEmail/>
                        <span className="gb--emphasize gb--emphasize-info">{email}</span>
                    </Row>
                    <Translation translationKey="check_order.buyer_info_section.email_note"/>
                </Column>
            </div>
            <div className="gb--card">
                <Row center justify className="gb--card-title">
                    <Translation translationKey="sys.total"/>
                </Row>
                <PaymentSummary/>
            </div>
        </>
    )
}

export default PaymentInfoSection